import { render, staticRenderFns } from "./service_modal.vue?vue&type=template&id=bf42fc6c&scoped=true&"
import script from "./service_modal.vue?vue&type=script&lang=js&"
export * from "./service_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf42fc6c",
  null
  
)

export default component.exports